<script setup lang="ts">
import { ref, computed } from 'vue'

const props = defineProps({
  maxCounter: {
    type: Number,
    required: false,
    default: 100,
  },
  pricePerUnit: {
    type: Number,
    required: true,
  },
})

const counter = ref(1)
const getCurrentTotalPrice = computed(() => {
  return counter.value * props.pricePerUnit
})


const emit = defineEmits({
  update(counter: number) {
    return counter
  }
})

function incrementCounter() {
  counter.value++
  emit('update', counter.value)
}

function decrementCounter() {
  counter.value--
  emit('update', counter.value)
}
</script>

<template>
  <div
    class="gap-y-1 text-xl bg-bfh-sub rounded grid grid-cols-1 p-4 text-center border border-solid border-bfh-border w-full md:w-[30rem] md:grid-cols-5">
    <p>{{ $t('trade.currentPrice') }}</p>
    <span></span>
    <p>{{ $t('trade.buyQuantity') }}</p>
    <span></span>
    <p>{{ $t('trade.totalPrice') }}</p>
    <p>{{ pricePerUnit.toLocaleString() }}{{ $t('common.bpc') }}</p>
    <p>x</p>
    <p class="w-full flex font-bold justify-center gap-x-8 md:w-20 md:justify-between md:gap-x-0">
      <button @click="decrementCounter" :disabled="counter <= 1">
        <fa-icon :icon="['fal', 'arrow-alt-down']" class="isLimitHeroExpItem" />
      </button>
      {{ counter }}
      <button @click="incrementCounter" :disabled="counter >= maxCounter">
        <fa-icon :icon="['fal', 'arrow-alt-up']" class="isLimitHeroExpItem" />
      </button>
    </p>
    <p>=</p>
    <p>{{ getCurrentTotalPrice }}{{ $t('common.bpc') }}</p>
  </div>
</template>

<style lang="scss" scoped>
@media (max-width: $breakpoint) {
  p:nth-of-type(2) {
    grid-row-start: 3;
  }

  p:nth-of-type(3) {
    grid-row-start: 5;
  }

  p:nth-of-type(5) {
    display: none;
  }

  p:nth-of-type(7) {
    display: none;
  }

  span {
    display: none;
  }
}
</style>
